import {throttle} from 'lodash'
import {v4} from 'uuid'

import {store} from '~/stores'

import {isBrowser} from '../isBrowser'
import {formatVersion} from '../number'
import {isIOS} from '../ua'

import './dsbridge'

function safeURL(url: string) {
  return url.startsWith('http') ? url : `${window.location.origin}${url}`
}

const isSafe = (safeIOS = '1.0.0', safeAndroid = '1.0.0') => {
  // 只对线上生效
  if (!isBrowser()) return false
  if (ENV !== 'production') return true
  const ua = window.navigator.userAgent
  const safeVersion = isIOS(ua) ? safeIOS : safeAndroid
  const {h_wanxiang} = store.getState().deviceInfo
  return formatVersion(h_wanxiang) >= formatVersion(safeVersion)
}

const callhandler = (...args) => {
  const argCount = args.length
  console.log('callhandler args=======>', args)
  if (argCount === 1) {
    const [name] = args
    window.bridge.call(name)
  }
  if (argCount === 2) {
    const [name, data] = args
    window.bridge.call(name, data)
  }
  if (argCount === 3) {
    const [name, data, cb] = args
    window.bridge.call(name, data, (res) => {
      if (cb) {
        cb(res)
      }
    })
  }
}

// 若需要新增sdk方法，请联系客户端，并确认该版本在客户端各个版本的sdk中都已支持
export const ds = {
  //  基础能力
  hasNativeMethod(name: string, type: 'all' | 'syn' | 'asyn' = 'all') {
    return Boolean(window.bridge?.hasNativeMethod?.(name, type))
  },
  setNavigation({title}: {title: string}) {
    callhandler('setNavigation', {title})
  },
  openWindow: throttle((url: string) => {
    callhandler('openWindow', {url: safeURL(url)})
  }, 2000),
  closeWindow() {
    callhandler('closeWindow')
  },
  triggerRouter(router: string) {
    callhandler('triggerRouter', {router})
  },

  useFavorPointAction(obj) {
    return new Promise((resolve) => {
      callhandler('useFavorPointAction', obj, (res) => {
        resolve(res)
      })
    })
  },

  getDeviceInfo() {
    return new Promise((resolve) => {
      callhandler('getDeviceInfo', {}, (res) => {
        if (typeof res === 'string') {
          res = JSON.parse(res)
        }
        resolve(res)
      })
    })
  },
  showGiveFiveStarDlg(obj) {
    return new Promise((resolve) => {
      callhandler('showGiveFiveStarDlg', obj, (res) => {
        resolve(res)
      })
    })
  },

  showSelectRelationDlg(obj) {
    return new Promise((resolve) => {
      callhandler('showSelectRelationDlg', obj, (res) => {
        resolve(res)
      })
    })
  },
  saveImage(src) {
    callhandler('saveImage', {src})
  },
  recharge(obj) {
    return new Promise((resolve) => {
      callhandler('recharge', obj, (res) => {
        resolve(res)
      })
    })
  },
  showRewardedAd({ad_session_id}: {ad_session_id: string}) {
    return new Promise<void>((resolve) => {
      callhandler('showRewardedAd', {ad_session_id}, () => {
        resolve()
      })
    })
  },
  shareLink({link, title, desc, img_url, extra = ''}) {
    return new Promise((resolve) => {
      callhandler('shareLink', {link, title, desc, img_url, extra}, (data) => {
        // data: {ret: 1 / -1} 1: 分享成功，-1 分享失败
        resolve(data)
      })
    })
  },
}
